import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { GOSPEL_SIX_TRUTHS } from "@/lib/nav";

export default function Gospel() {
  return (
    <>
      <PageHero
        eyebrow="The Gospel"
        title="Good news, in six clear truths."
        subtitle="The Gospel is not moral advice or self-improvement. It is the announcement of what God has done in Christ — and what that means for you."
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {GOSPEL_SIX_TRUTHS.map((t) => (
              <div key={t.n} className="paper-card p-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-serif text-4xl text-gold" style={{ fontWeight: 500 }}>0{t.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl text-ink" style={{ fontWeight: 500 }}>{t.title}</h3>
                    <p className="eyebrow text-forest mt-1">{t.scripture}</p>
                  </div>
                </div>
                <p className="body-copy mt-6 text-ink-muted">{t.body}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 border-l-4 border-gold pl-8 py-6">
            <h3 className="heading-3">Your response</h3>
            <p className="body-copy mt-4 text-ink-muted max-w-3xl">
              The Gospel calls for a response. Not a religious ritual. Not perfection. Just an honest turn from sin
              (repentance) and trust in Jesus Christ (faith). You may pray something like this — from your heart, not
              from a script:
            </p>
            <blockquote className="mt-6 font-serif text-2xl italic leading-snug text-ink max-w-3xl">
              "Lord Jesus, I know I have sinned and cannot save myself. Thank You for dying for my sins and rising
              again. I turn from my sin and trust You alone. Please forgive me, give me new life, and help me follow
              You from today. Amen."
            </blockquote>
          </div>

          <div className="mt-14 text-center">
            <p className="body-copy text-ink-muted">If you prayed that today, we would love to know.</p>
            <div className="mt-6 flex justify-center gap-3">
              <Link to="/contact#ask" className="btn-primary">Tell us</Link>
              <Link to="/start-here" className="btn-ghost">What Next?</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
